// src/pages/ResetPasswordPage.jsx

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../services/authService";
import { Container, Paper, Typography, TextField, Button, Box } from "@mui/material";
import { useSnackbar } from "notistack";
import AuthHeader from "../components/AuthHeader";

function ResetPasswordPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get("token");
    const e = params.get("email");
    if (t) setToken(t);
    if (e) setEmail(e);
  }, [location.search]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const data = await resetPassword(token, email, newPassword);
      enqueueSnackbar(data.message || "Password reset success", { variant: "success" });
      navigate("/login");
    } catch (err) {
      if (err.response && err.response.data?.error) {
        enqueueSnackbar(err.response.data.error, { variant: "error" });
      } else {
        enqueueSnackbar("Failed to reset password", { variant: "error" });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <AuthHeader />
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }} elevation={2}>
          <Typography variant="h5" gutterBottom>
            Reset Password
          </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <Typography>
            Email: <strong>{email || "N/A"}</strong>
          </Typography>
          <TextField
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            fullWidth
          />
          <Button
            variant="contained"
            type="submit"
            disabled={loading}
          >
            {loading ? "Processing..." : "Set New Password"}
          </Button>
        </Box>
      </Paper>
    </Container>
    </>
  );
}

export default ResetPasswordPage;